import { RootState } from 'store/store';

export const getIsCreateTicketShare = (state: RootState): boolean =>
	state.ticketShareReducer.isCreateTicketShareOpen;

export const getCurrentTicketShares = (state: RootState) =>
	state.ticketShareReducer.currentTicketPermissions;

export const getIsCurrentTicketSharesLoading = (state: RootState) =>
	state.ticketShareReducer.isCurrentTicketSharesLoading;
